import { useRef, useState } from "react";
import { Play, Volume2, VolumeX } from "lucide-react";
import { API } from "../../lib/api";

export function TrailerPlayer({ slug, title, blurb, poster }) {
  const ref = useRef();
  const [playing, setPlaying] = useState(false);
  const [ended, setEnded] = useState(false);
  const [muted, setMuted] = useState(false);
  const play = () => { setEnded(false); ref.current.currentTime = 0; ref.current.play(); };
  return (
    <section className="relative rounded-xl overflow-hidden border border-amber-500/30 bg-black shadow-[0_0_50px_rgba(157,78,221,0.3)] max-w-sm" data-testid="book-trailer">
      <video ref={ref} src={`${API}/public/books/${slug}/trailer`} playsInline preload="metadata" poster={poster || undefined} muted={muted} className="w-full aspect-[2/3] object-cover"
        onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => { setPlaying(false); setEnded(true); }} data-testid="book-trailer-video" />
      <div className={`absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-black via-black/70 to-transparent pointer-events-none transition-opacity duration-700 ${playing && !ended ? "opacity-0" : "opacity-100"}`}>
        <p className="eyebrow mb-1">Book trailer</p>
        <p className="font-display text-2xl text-white drop-shadow-[0_0_12px_rgba(199,125,255,0.9)] leading-tight">{title}</p>
        {ended && blurb && <p className="text-xs text-slate-300 mt-2 line-clamp-3 fade-up">{blurb}</p>}
      </div>
      {!playing && (
        <button onClick={play} className="absolute inset-0 flex items-center justify-center group" aria-label="Play trailer" data-testid="book-trailer-play">
          <span className="w-16 h-16 rounded-full bg-amber-600/90 flex items-center justify-center shadow-[0_0_30px_rgba(199,125,255,0.8)] group-hover:scale-110 transition-transform"><Play size={26} className="text-white ml-1" /></span>
        </button>
      )}
      <button onClick={() => setMuted(!muted)} className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/60 flex items-center justify-center text-amber-100 hover:bg-amber-600 transition-colors" aria-label={muted ? "Unmute" : "Mute"} data-testid="book-trailer-mute">
        {muted ? <VolumeX size={14} /> : <Volume2 size={14} />}</button>
    </section>
  );
}
